import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { convertUTCToLocalDate } from "../../utils/utcToLocalTimeConvertor";
import FeaturePanel from "../../components/FeaturePanel";
import Breadcrumb from "../../components/Breadcrumb";
import { scrollToTop } from "../../utils/scrollToTop";
import BlogService from "../../api/services/blogService";
import InfiniteScroll from "react-infinite-scroll-component";
import { SpinnerLoader } from "../../components/Loader";
import ProductShimmerUI from "../neushop/home/components/ProductShimmerUI";

function BlogPage() {
  const [blogsList, setBlogsList] = useState([]);
  const routes = [{ text: "Astrology Blogs" }];
  const { getBlogsList } = BlogService();
  const [pageFlag, setPageFlag] = useState(true);
  const pageRef = useRef(1);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    pageRef.current = 1;
    scrollToTop();
    fetchBlogsList();
  }, []);

  const fetchBlogsList = async () => {
    try {
      const { result, data, msg } = await getBlogsList(pageRef.current);
      if (result && data && Array.isArray(data) && data.length > 0) {
        pageRef.current += 1;
        setBlogsList((preValue) => [...preValue, ...data]);
        if (!pageFlag) {
          setPageFlag(true);
        }
        return;
      }
      setPageFlag(false);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section className="tw-mb-0 tw-mt-0 tw-pt-7">
        <div className="container-fluid-lg tw-mb-0">
          <Breadcrumb routes={routes} />
        </div>
      </section>
      <section className="blog-section section-b-space">
        <div className="container-fluid-lg">
          {isLoading ? (
            <ProductShimmerUI />
          ) : (
            blogsList.length > 0 && (
              <InfiniteScroll
                key={pageFlag}
                dataLength={blogsList.length}
                next={fetchBlogsList}
                style={{ overflow: "visible" }}
                hasMore={pageFlag}
                scrollThreshold="50%"
                loader={
                  <div className="tw-h-[140px] tw-w-full flex-item-center">
                    <SpinnerLoader />
                  </div>
                }
              >
                <div className="row g-sm-4 g-3">
                  {blogsList?.map((list, index) => {
                    return (
                      <Link
                        to={`/astrology-blog/${list?.slug}`}
                        key={index}
                        className="tw-no-underline tw-text-black col-12 col-sm-6 col-md-4 col-xl-3 tw-cursor-pointer tw-mb-4"
                      >
                        <div>
                          <div className="blog-box wow fadeInUp">
                            <div className="blog-image">
                              <img
                                style={{
                                  objectFit: "",
                                }}
                                src={list.image}
                                className="bg-img blur-up lazyload img-fluid tw-w-full tw-h-[206px]"
                                alt={`blog_${list?.title}`}
                                loading="lazy"
                              />
                            </div>

                            <div className="blog-contain tw-pl-1.5 tw-py-1.5">
                              <div className="blog-label tw-flex tw-flex-col tw-items-start tw-gap-y-2.5">
                                <h3 className="slider-card-heading tw-my-0 overflow-ellipsis">
                                  {list.title}
                                </h3>
                                <div className="tw-text-para-color tw-flex tw-gap-x-1">
                                  <span>{list?.author}</span>
                                  <span>|</span>
                                  <span>
                                    {convertUTCToLocalDate(list?.updatedAt)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </InfiniteScroll>
            )
          )}
        </div>
      </section>
      <FeaturePanel />
      <br />
      <br />
    </>
  );
}

export default BlogPage;
